import { omit } from "lodash";
import toPairs from "lodash.topairs";
import { SET_ALL_DATA, SET_ITEM, DELETE_ITEM } from "./actions";

export const notes = (state = {}, action) => {
  switch (action.type) {
    case SET_ALL_DATA: {
      return { ...state, data: action.payload };
    }
    case SET_ITEM: {
      const { id, data } = action.payload;
      return { ...state, data: { ...state.data, [id]: data } };
    }
    case DELETE_ITEM: {
      const { id } = action.payload;
      return { ...state, data: omit(state.data, [id]) };
    }
    default:
      return state;
  }
};

export const getNotesData = (notesObj) => fromObjToArray(notesObj);

const fromObjToArray = (notesObj) =>
  toPairs(notesObj).map(([key, value]) => ({ ...value, id: key }));

export const getPendingNotesCount = (notesState) => {
  const dataObj = notesState?.data || {};
  return Object.values(dataObj).filter((n) => !n.done).length;
};